export default function () {
  return (
    <div className="frame container nav-links">
      <a
        aria-label="Resume"
        className="frame__title-back"
        href="https://drive.google.com/file/d/1VQ5tRhiufS6eYR9tkewo47OmAycJlVmU/view?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="oh__inner">Resume</span>
        <svg width="18px" height="18px" viewBox="0 0 24 24">
          <path
            vectorEffect="non-scaling-stroke"
            d="M18.25 15.5a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75h-9a.75.75 0 000 1.5h7.19L6.22 16.72a.75.75 0 101.06 1.06L17.5 7.56v7.19c0 .414.336.75.75.75z"
          ></path>
        </svg>
      </a>

      <div className="social-links">
        <a target="_blank" href="https://www.behance.net/akbaralinabiyev1">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Behance.svg"}
            alt=""
          />
        </a>
        <a target="_blank" href="https://www.instagram.com/prod.uiux/">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Instagram.svg"}
            alt=""
          />
        </a>
        <a target="_blank" href="https://twitter.com/zukunftigerarzt">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Twitter.svg"}
            alt=""
          />
        </a>
        <a target="_blank" href="https://www.linkedin.com/in/akbarali-nabiev/">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/Linkedin.svg"}
            alt=""
          />
        </a>
      </div>
    </div>
  );
}
